const LONG_TITLE_LENGTH = 28;

export const isLongTitle = (title: string) => title.length > LONG_TITLE_LENGTH;
